import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDRxmON-vW-MyX5JwX6x-2nUDNnFMRo-pI",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "databolta-hai.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "databolta-hai",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "databolta-hai.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "568629483905",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:568629483905:web:f159b59a51209459c2f080",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-ESVXXT568P"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const db = getFirestore(app);

export { auth, googleProvider, db };
